<div class="loading-overlay" #spinnerElement style="display:none">
    <app-full-page-spinner>
        Loading...
    </app-full-page-spinner>
</div>

<div id="main-wrap" class="main-wrap">
    <mat-toolbar class="tool-bar">
        <div class="flex-1 flex justify-content-space-between align-items-center">
            <!-- logo -->
            <div (click)="logoClick()" class="cursor-pointer" style="height: 30px;">
                <img *ngIf="!isFleetUrl && !userIsFleet()" src="images/main-logo-horizontal-light.png"
                     i18n-alt
                     alt="Wrench Logo"
                     style="z-index: 1;"
                     height="30">
                <img *ngIf="isFleetUrl || loggedIn && userIsFleet()" src="images/main-logo-fleet-horizontal-light.png"
                     i18n-alt
                     alt="Wrench Logo"
                     style="z-index: 1"
                     height="30">
            </div>

            <div *ngIf="!loggedIn" class="flex gap-row-sm">
                <div class="flex gap-row-sm" *ngIf="!isBookingFlow">
                    <button mat-flat-button
                            color="accent"
                            [routerLink]="['/book']"
                            aria-label="Book button">
                        Book Now
                    </button>
                </div>

                <div class="hide-mobile">
                    <!-- todo do we want this link!? it will currently never show. -->
                    <button *ngIf="isFleetUrl" mat-button>
                        <a style="color: white;" href="{{fleetUrl}}">
                            Fleets
                        </a>
                    </button>

                    <button mat-button>
                        <a style="color: white;" href="{{towingUrl}}">Towing and Roadside</a>
                    </button>

                    <button mat-button>
                        <a style="color: white;" href="{{helpUrl}}">
                            Help
                        </a>
                    </button>

                    <button mat-button>
                            <a style="color: white;"
                               href="https://recruiting.paylocity.com/recruiting/jobs/All/d7b1e79c-6dc2-4c5b-9478-35c4c44cbcae/Wrench-Inc"
                               target="_blank" rel="noopener noreferrer nofollow">
                                Join the Team
                            </a>
                    </button>

                    <button mat-button [routerLink]="['/login']">
                        Login
                    </button>
                </div>

                <div *ngIf="isBookingFlow">
                    <a href="tel:+18449973624">
                        <button
                            class="hide-desktop"
                            mat-mini-fab
                            color="accent"
                            i18n-aria-label
                            aria-label="Call Wrench">
                            <fa-icon [icon]="['fad', 'phone']" [classes]="['color-light']"></fa-icon>
                        </button>

                        <button
                            class="hide-mobile"
                            mat-flat-button
                            (click)="callPhoneNumber()"
                            color="accent"
                            i18n-aria-label
                            aria-label="Call Wrench">
                            <fa-icon [icon]="['fad', 'phone']" [classes]="['color-light']"></fa-icon>
                            <span i18n>1-844-997-3624</span>
                        </button>
                    </a>
                </div>

                <button mat-button
                        class="hide-desktop"
                        (click)="sidenav.toggle()"
                        aria-label="Navigation menu">
                    <mat-icon>menu</mat-icon>
                </button>

            </div>

            <div class="flex align-items-baseline gap-row-sm" *ngIf="loggedIn">
                <button mat-flat-button
                        *ngIf="!isBookingFlow"
                        color="accent"
                        [routerLink]="['/book']"
                        aria-label="Book button">
                    Book Now
                </button>

                <div *ngIf="isBookingFlow">
                    <a href="tel:+18449973624">
                        <button
                            class="hide-desktop"
                            mat-mini-fab
                            color="accent"
                            i18n-aria-label
                            aria-label="Call Wrench">
                            <fa-icon [icon]="['fad', 'phone']" [classes]="['color-light']"></fa-icon>
                        </button>

                        <button
                            class="hide-mobile"
                            mat-flat-button
                            (click)="callPhoneNumber()"
                            color="accent"
                            i18n-aria-label
                            aria-label="Call Wrench">
                            <fa-icon [icon]="['fad', 'phone']" [classes]="['color-light']"></fa-icon>
                            <span i18n>1-844-997-3624</span>
                        </button>
                    </a>
                </div>

                <button mat-button
                        (click)="sidenav.toggle()"
                        aria-label="Navigation menu">
                    <mat-icon>menu</mat-icon>
                </button>
            </div>

        </div>
    </mat-toolbar>

    <mat-sidenav-container style="top: 60px;" autosize>
        <mat-sidenav #sidenav mode="over" position="end">
            <app-fleet-header *ngIf="userIsFleet()" [isMaster]="user?.master" (toggleNav)="sidenav.toggle()"
                              [loginName]="loginName">
            </app-fleet-header>

            <mat-selection-list multiple="false" *ngIf="!userIsFleet() && loggedIn">
                <mat-list-option (click)="sidenav.toggle()" [routerLink]="['/book']">
                    Book a Service
                </mat-list-option>

                <mat-list-option (click)="sidenav.toggle()" [routerLink]="['/appointments']">
                    Appointments
                </mat-list-option>

                <mat-list-option (click)="sidenav.toggle()" [routerLink]="['/quotes']">
                    Quotes
                </mat-list-option>

                <mat-list-option (click)="sidenav.toggle()" [routerLink]="['/garage']">
                    Garage
                </mat-list-option>

                <mat-list-option (click)="sidenav.toggle()" [routerLink]="['/ppm']">
                    TotalCare
                </mat-list-option>

                <mat-list-option (click)="sidenav.toggle()" [routerLink]="['/account']">
                    Account Details
                </mat-list-option>

                <mat-list-option (click)="sidenav.toggle()" [routerLink]="['/notifications']">
                    Notifications
                </mat-list-option>

                <mat-list-option (click)="sidenav.toggle()" [routerLink]="['/discounts']">
                    Rewards
                </mat-list-option>

                <mat-list-option (click)="sidenav.toggle()">
                    <a style="color: white;" href="/service/towing-and-roadside-assistance">Towing and Roadside</a>
                </mat-list-option>

                <mat-list-option (click)="sidenav.toggle()" [routerLink]="['/login']">
                    Logout
                </mat-list-option>
            </mat-selection-list>

            <mat-selection-list multiple="false" *ngIf="!loggedIn">
                <mat-list-option (click)="sidenav.toggle()" *ngIf="isFleetUrl">
                    <a style="color: white;" href="{{fleetUrl}}">Fleets</a>
                </mat-list-option>

                <mat-list-option (click)="sidenav.toggle()">
                    <a style="color: white;" href="{{towingUrl}}">Towing and Roadside</a>
                </mat-list-option>

                <mat-list-option (click)="sidenav.toggle()" [routerLink]="['/faq']">
                    <a style="color: white;" href="{{helpUrl}}">Help</a>
                </mat-list-option>

                <mat-list-option (click)="sidenav.toggle()">
                    <a style="color: white;"
                       href="https://recruiting.paylocity.com/recruiting/jobs/All/d7b1e79c-6dc2-4c5b-9478-35c4c44cbcae/Wrench-Inc"
                       target="_blank"
                       rel="noopener noreferrer nofollow">
                        Join the Team
                    </a>
                </mat-list-option>

                <mat-list-option (click)="sidenav.toggle()" [routerLink]="['/login']">
                    Login
                </mat-list-option>
            </mat-selection-list>

        </mat-sidenav>

        <mat-sidenav-content>
            <!--=== Body ===-->
            <div id="page-wrapper" style="overflow: auto;" class="page-wrapper flex-1"
                 [class.banner-padding]="isBannerVisible() && showHeaderFooter">

                <router-outlet></router-outlet>
            </div>

            <div class="desktop flex desktop-footer justify-content-space-between gap-row-md align-items-center">
                <mat-card-subtitle class="font-size-12 light-gray-text margin-0" i18n>Wrench, Inc.</mat-card-subtitle>
                <mat-card-subtitle class="font-size-12 light-gray-text margin-0">BAR License: ARD304522 | FL License: MV108509</mat-card-subtitle>
            </div>

            <div class="mobile flex mobile-footer justify-content-space-between gap-row-md align-items-center">
                <mat-card-subtitle class="font-size-9 light-gray-text margin-0" i18n>Wrench, Inc.</mat-card-subtitle>
                <mat-card-subtitle class="font-size-9 light-gray-text margin-0">BAR License: ARD304522 | FL License: MV108509</mat-card-subtitle>
            </div>
            <!--=== End Body ===-->
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
